import { z } from 'zod';
import { adminProductCursorSchema } from '../const/adminProductCursorSchema';
import { adminProductSortingSchema } from '../const/adminProductSortingSchema';

export const getAdminProductsInfiniteInput = z.object({
    search: z.string().trim().optional().nullable(),
    sort: adminProductSortingSchema.default('created-new'),
    limit: z.number().int().min(1).max(100).default(20),
    cursor: adminProductCursorSchema.optional().nullable(),
});

export type GetAdminProductsInfiniteInput = z.infer<typeof getAdminProductsInfiniteInput>;
